export const DATA_TARGETING_SET_ACL_OBJECTS = [
    'DetailsDataSetsComponent',
    'DataTargetingSetNew',
    'DataTargetingSetList'
];
